// extracted by mini-css-extract-plugin
export default {"container":"styles_container__65+6x","image":"styles_image__c90HY","title":"styles_title__gHGsK","profiles":"styles_profiles__vd6-B"};